import OfferHelp from "./OfferHelp"
import EvaluateTicket from "./EvaluateTicket"

const offerHelpRoutes = [
  { Component: EvaluateTicket, path: "/offer_help/evaluate/:ticket_id" },
  { Component: OfferHelp, path: "/offer_help" },
]

export default offerHelpRoutes
